import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=0c92d1bc&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=javascript&"
export * from "./Edit.vue?vue&type=script&lang=javascript&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=0c92d1bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c92d1bc",
  null
  
)

export default component.exports